/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

export const mapFloorToPlotY = floor => (floor < 0 ? floor + 1 : floor);

export const mapPlotYToFloor = plotY => (plotY <= 0 ? plotY - 1 : plotY);

export const mapFloorsToPlotY = floors => floors.map(mapFloorToPlotY);
